export const environment = {
    envName: 'dev',
    version: '1.1',
    appUrl: 'https://kbh.mfdevops.com',
    currentDomain: 'DEV',
    transactionAPIEndpoint: '/KMFUnification',
    cugAPIEndpoint: '/cug',
    cugBrockerCode: '/INVESTOR',
    plexAPIEndpoint: 'Plex',
    kbhEndpoint: 'kotakbh',
    crmMappingEndpoint: 'CrmMapping',
    businessDateEndpoint: 'businessdate',
    newPlexAPIEndpoint: 'PlexNewAPI',
    platform: 'web',
    logicAPI: '/bh',
    cloudErrUrl: 'https://s6roj16ijk.execute-api.ap-south-1.amazonaws.com/default/KotakBusinesshub_Logger',
    apiEndpoints: {
        Plex: 'https://kplex.kotakmf.in',
        CrmMapping: '',
        KMFUnification: '',
        INVESTOR: '',
        kotakbh: '',
        cug: '',
        KOTAKDISAPI: '',
        KOTAKDISAPICUG: '',
        kotakmf: '',
        OTMAPI: '',
        PlexNew: '',
    },
    firebaseConfig: {
        apiKey: 'AIzaSyAfIol-yQoSFYOAn47ttKO8d4QugysE9pA',
        authDomain: 'kotak-business-hub---new.firebaseapp.com',
        projectId: 'kotak-business-hub---new',
        storageBucket: 'kotak-business-hub---new.appspot.com',
        messagingSenderId: '204911375269',
        appId: '1:204911375269:web:a3999cfcb6000e9bf52e4c',
        measurementId: 'G-5HTG8RQ9BV',
    },
};
